<template>
  <div>
    <dx-grid
      :url="url"
      name="businesses"
      :columns="columns"
      :title="title"
      :actions="actions"
      :beforeSetupGrid="beforeSetupGrid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>

    <!-- ── Add business dialog ── -->
    <v-dialog v-model="addDialog" max-width="600" persistent>
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">
          <v-icon color="success" class="mr-2">mdi-domain</v-icon>
          Add Business
        </v-card-title>

        <v-text-field
          v-model="form.name"
          label="Business Name *"
          prepend-inner-icon="mdi-domain"
          outline
          dense
        ></v-text-field>
        <v-layout row wrap>
          <v-flex xs12 sm6 class="pr-2">
            <v-text-field
              v-model="form.contactPerson"
              label="Contact Person"
              prepend-inner-icon="mdi-account"
              outline
              dense
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="pl-2">
            <v-combobox
              v-model="form.contactPersonTitle"
              :items="contactPersonTitleOptions"
              label="Contact Title"
              prepend-inner-icon="mdi-account-card-details"
              outline
              dense
              hide-no-data
            ></v-combobox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6 class="pr-2">
            <v-text-field
              v-model="form.phone"
              label="Phone"
              prepend-inner-icon="mdi-phone"
              outline
              dense
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="pl-2">
            <v-text-field
              v-model="form.email"
              label="Email"
              prepend-inner-icon="mdi-email"
              outline
              dense
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-text-field
          v-model="form.address"
          label="Address"
          prepend-inner-icon="mdi-map-marker"
          outline
          dense
        ></v-text-field>
        <v-text-field
          v-model="form.ein"
          label="EIN"
          prepend-inner-icon="mdi-file-document-outline"
          outline
          dense
        ></v-text-field>
        <v-select
          :items="agents"
          item-text="name"
          item-value="agentID"
          v-model="form.agentID"
          label="Billing Agent"
          prepend-inner-icon="mdi-account-tie"
          outline
          dense
          clearable
          hide-details
        ></v-select>
        <v-textarea
          v-model="form.note"
          label="Note"
          prepend-inner-icon="mdi-note-text"
          outline
          dense
          rows="2"
        ></v-textarea>

        <v-card-actions class="pr-0 pt-2 pb-0 mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeAddDialog">Cancel</v-btn>
          <v-btn :loading="saving" color="success" @click="saveBusiness">
            <v-icon left small>mdi-content-save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "Businesses",
    url: "",
    term: "",
    currentTerm: "",
    actions: [],
    addDialog: false,
    saving: false,
    contactPersonTitleOptions: [
      "Owner",
      "President",
      "CEO",
      "CFO",
      "Controller",
      "Office Manager",
      "HR Manager",
      "Payroll Manager",
      "Bookkeeper",
      "Accountant",
      "Manager",
    ],
    agents: [],
    form: {
      businessID: 0,
      name: "",
      contactPerson: "",
      contactPersonTitle: "",
      phone: "",
      email: "",
      address: "",
      ein: "",
      note: "",
      agentID: null,
    },
    columns: [
      {
        label: "Business Name",
        field: "businessName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Contact Person",
        field: "contactPerson",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Contact Title",
        field: "contactPersonTitle",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Phone",
        field: "businessPhone",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Email",
        field: "businessEmail",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address",
        field: "address",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "EIN",
        field: "eIN",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Agent",
        field: "agentName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Linked Families",
        field: "linkedFamilies",
        type: "number",
        visible: true,
        width: 130,
        alignment: "center",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Students",
        field: "coveredStudents",
        type: "number",
        visible: true,
        width: 140,
        alignment: "center",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Contract Total",
        field: "annualTotal",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Signed Contract",
        field: "hasSignedContract",
        type: "boolean",
        visible: true,
        width: 140,
        alignment: "center",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Billed Monthly",
        field: "monthlyTotal",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Billed",
        field: "totalCharged",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Total Paid",
        field: "totalPaid",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Paid",
        field: "totalActuallyPaid",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Scheduled",
        field: "totalScheduled",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Balance",
        field: "balance",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Running Balance",
        field: "runningBalance",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Actual Balance",
        field: "actualBalance",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Billing Account",
        field: "accountID",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Date Created",
        field: "dateCreated",
        type: "date",
        format: "MM/dd/yyyy",
        sortOrder: "desc",
        sortIndex: 0,
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.loadAgents();
  },
  methods: {
    async beforeSetupGrid() {
      const [terms, currentTerm] = await Promise.all([
        this.loadTerms(),
        this.loadCurrentTerm(),
      ]);

      this.currentTerm = currentTerm || "";
      this.term = this.currentTerm;

      this.actions.push({
        text: "Term",
        type: "select",
        align: "left",
        values: terms,
        value: this.term,
        onSelected: this.onTermSelected,
      });

      this.actions.push({
        text: "Add Business",
        action: this.openAddDialog,
      });

      this.buildUrl();
    },
    async loadCurrentTerm() {
      try {
        const response = await this.$http.get(
          "api/businesses/getCurrentTerm"
        );

        return response && response.value ? response.value : response;
      } catch (e) {
        return "";
      }
    },
    async loadTerms() {
      try {
        const response = await this.$http.get(
          "api/businesses/getContractTerms"
        );

        return this.unwrap(response);
      } catch (e) {
        return [];
      }
    },
    unwrap(response) {
      const data = response && response.value ? response.value : response;

      return Array.isArray(data) ? data : [];
    },
    buildUrl() {
      this.url = "Businesses?term=" + encodeURIComponent(this.term || "");
    },
    onTermSelected(value) {
      this.term = value || "";

      this.buildUrl();

      if (this.$refs.grid) {
        this.$refs.grid.reloadDataSource(this.url);
      }
    },
    onRowClicked(row) {
      this.$router.push({
        name: "BusinessView",
        params: { id: row.businessID, term: row.term },
      });
    },
    async loadAgents() {
      try {
        const response = await this.$http.get("api/businesses/getAgents");
        this.agents = Array.isArray(response) ? response : [];
      } catch (e) {
        this.agents = [];
      }
    },
    openAddDialog() {
      this.form = {
        businessID: 0,
        name: "",
        contactPerson: "",
        contactPersonTitle: "",
        phone: "",
        email: "",
        address: "",
        ein: "",
        note: "",
        agentID: null,
      };
      this.addDialog = true;
    },
    closeAddDialog() {
      this.addDialog = false;
    },
    async saveBusiness() {
      if (!this.form.name || !this.form.name.trim()) {
        this.$notify({
          text: "Business name is required",
          group: "notification",
          type: "error",
        });
        return;
      }

      try {
        this.saving = true;

        await this.$http.post("api/businesses/save", {
          businessID: this.form.businessID,
          name: this.form.name,
          contactPerson: this.form.contactPerson,
          contactPersonTitle: this.form.contactPersonTitle,
          phone: this.form.phone,
          email: this.form.email,
          address: this.form.address,
          ein: this.form.ein,
          note: this.form.note,
          agentID: this.form.agentID || null,
        });

        this.$notify({
          text: "Business added successfully",
          group: "notification",
          type: "success",
        });

        this.closeAddDialog();

        if (this.$refs.grid) {
          this.$refs.grid.reloadGrid();
        }
      } catch (e) {
        this.$notify({
          text: this.getErrorMessage(e, "Failed to save business"),
          group: "notification",
          type: "error",
        });
      } finally {
        this.saving = false;
      }
    },
    getErrorMessage(error, fallback) {
      if (error && error.Message) return error.Message;
      if (error && error.message) return error.message;
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.Message
      )
        return error.response.data.Message;

      return fallback;
    },
  },
};
</script>
